import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-consent-modal',
    templateUrl: './consent-modal.component.html',
    styleUrls: ['./consent-modal.component.scss'],
    standalone: false
})
export class ConsentModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConsentModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {dialogRef.disableClose = true; }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onConfirm() {
    this.dialogRef.close(true);
  }

}
